import * as React from 'react';
import Grid from '@mui/material/Grid2';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Button from "@mui/material/Button";
import {useEffect, useState} from "react";
import FinanceStatus from "./FinanceStatus";

export default function MainGrid() {
    return (
        <Box sx={{width: '100%', maxWidth: {sm: '100%', md: '1700px'}}}>
            {/* cards */}
            <Typography component="h2" variant="h2" sx={{mb: 2}}>
                Finanzstatus
            </Typography>
            <FinanceStatus/>
        </Box>
    );
}